import React, { useState } from "react"
import { Col, Input, Row } from "reactstrap"
import { SaveButton } from "components/Buttons"
import { connect } from "react-redux"
import { editCategory, hideEditCategoryModal } from "store/actions"

let EditCategoryModal = ({
  hideEditCategoryModal,
  loading,
  editCategory,
  selectedCategory,
  vendorId,
}) => {
  const [inputValue, setInputValue] = useState(selectedCategory?.name)

  return (
    <React.Fragment>
      <Row>
        <Col xs={12} className="mb-3 mt-1">
          <Input
            value={inputValue}
            onChange={event => {
              setInputValue(event.target.value)
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <SaveButton
            type="button"
            fullWidth={true}
            color="danger"
            content="Cancel"
            onClick={hideEditCategoryModal}
          />
        </Col>
        <Col>
          <SaveButton
            content="Update"
            fullWidth={true}
            loading={loading}
            disabled={inputValue.trim().length === 0}
            onClick={() => {
              if (inputValue.trim().length) {
                editCategory(selectedCategory.id, {
                  vendor_id: parseInt(vendorId),
                  name: inputValue,
                  type: selectedCategory?.type,
                  delete_file: 0,
                  order: selectedCategory.order,
                  inventory: 0,
                })
              }
            }}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  loading: state.Categories.loading,
  vendorId: state.Login.vendorId,
})

const mapDispatchToProps = dispatch => ({
  editCategory: (categoryId, data) => dispatch(editCategory(categoryId, data)),
  hideEditCategoryModal: () => dispatch(hideEditCategoryModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(EditCategoryModal)
